export default __webpack_public_path__ + "static/media/aqi-bg2.cc9a1703.jpg";